/**
 *
 * @param {object} object object to null check
 * @param {{
 *   cause?: Error,
 *   fileName?: string,
 *   lineNumber?: number
 * }?} errorOptions
 */
const errorIfNoInput = (object, errorOptions={}) => {
  if (!object) throw new Error("no object to translate", errorOptions);
}

/**
 *
 * @param {{}} requiredParams objects in which all entries will be null checked
 * @param {{
 *   cause?: Error,
 *   fileName?: string,
 *   lineNumber?: number
 * }?} errorOptions
 */
const errorIfMissingRequired = (requiredParams, errorOptions) => {
  const paramKeys = Object.keys(requiredParams);
  let keysOfUndefined = [];
  paramKeys.forEach(key => {if (requiredParams[key] === undefined || requiredParams[key] === null) keysOfUndefined.push(key)});
  const undefinedCount = keysOfUndefined.length;
  if (undefinedCount > 0) {
    let errorMessage = "object missing required field";
    if (undefinedCount === 1) errorMessage += ` "${keysOfUndefined[0]}"`;
    else if (undefinedCount === 2) errorMessage += `s "${keysOfUndefined[0]}" and "${keysOfUndefined[1]}"`;
    else errorMessage += `s "${keysOfUndefined.slice(0, undefinedCount - 1).join(`", "`)}", and "${keysOfUndefined[undefinedCount - 1]}"`;
    throw new Error(errorMessage, errorOptions);
  }
}

export {errorIfNoInput, errorIfMissingRequired};
